import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { changePassword } from "../../services/settings";

const Password = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordError1, setPasswordError1] = useState("");
  const [inputPassOld, setInputPassOld] = useState("password");
  const [showOld, setShowOld] = useState(false);
  const [inputPassNew, setInputPassNew] = useState("password");
  const [showNew, setShowNew] = useState(false);
  const [inputPassConfirm, setInputPassConfirm] = useState("password");
  const [showConfirm, setShowConfirm] = useState(false);

  const handleShowOld = () => {
    setShowOld(!showOld);
    setInputPassOld(inputPassOld === "password" ? "text" : "password");
  };

  const handleShowNew = () => {
    setShowNew(!showNew);
    setInputPassNew(inputPassNew === "password" ? "text" : "password");
  };

  const handleShowConfirm = () => {
    setShowConfirm(!showConfirm);
    setInputPassConfirm(inputPassConfirm === "password" ? "text" : "password");
  };

  // Function to validate password
  const validatePassword = (password) => {
    // Regular expressions for validation
    const hasNumber = /\d/;
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

    // Check password length, presence of number, and special character
    if (
      password.length < 9 ||
      !hasNumber.test(password) ||
      !hasSpecialChar.test(password)
    ) {
      throw new Error(
        "Password must be at least 9 characters long and contain a number and a special character."
      );
    }
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setOldPassword(newPassword);
    // Validate password
    try {
      validatePassword(newPassword);
      setPasswordError(""); // Clear error message if validation passes
    } catch (error) {
      setPasswordError(error.message); // Set error message if validation fails
    }
  };
  const handlePasswordChange1 = (e) => {
    const newPassword1 = e.target.value;
    setNewPassword(newPassword1);
    // Validate password
    try {
      validatePassword(newPassword1);
      setPasswordError1(""); // Clear error message if validation passes
    } catch (error) {
      setPasswordError1(error.message); // Set error message if validation fails
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      setLoading(false);
      return;
    }
    try {
      const response = await changePassword({
        oldPassword: oldPassword,
        newPassword: newPassword,
      });
      toast.success(response.message);
    } catch (error) {
      if (error.response) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <div className="flex">
      <div className="w-[448px] p-4">
        <h1 className="text-[20px] font-semibold mt-2">Change Password</h1>
        <div className="flex flex-col">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col mt-6 relative">
              <label htmlFor="new-password">Old Password</label>
              <input
                onChange={handlePasswordChange}
                /* Updated to handlePasswordChange */ type={inputPassOld}
                id="new-password"
                placeholder="......."
                className="w-[348px] h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
              />
              {passwordError && (
                <span className="text-red-500 text-xs">{passwordError}</span>
              )}{" "}
              {/* Display password error */}
              <button
                type="button"
                className="absolute right-20 top-14"
                onClick={handleShowOld}
              >
                {showOld ? <FaEyeSlash /> : <FaEye />}{" "}
              </button>
            </div>

            <div className="flex flex-col mt-4 relative">
              <label htmlFor="confirm-password">New Password</label>
              <input
                onChange={handlePasswordChange1}
                type={inputPassNew}
                id="confirm-password"
                placeholder="....."
                className="w-[348px] h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
              />
              {passwordError1 && (
                <span className="text-red-500 text-xs">{passwordError1}</span>
              )}{" "}
              {/* Display password error */}
              <button
                type="button"
                className="absolute right-20 top-14"
                onClick={handleShowNew}
              >
                {showNew ? <FaEyeSlash /> : <FaEye />}{" "}
              </button>
            </div>

            <div className="flex flex-col mt-4 relative">
              <label htmlFor="confirm-password">Confirm Password</label>
              <input
                onChange={(e) => setConfirmPassword(e.target.value)}
                type={inputPassConfirm}
                id="confirm-password"
                placeholder="....."
                className="w-[348px] h-[50px] bg-gray-100 outline-none rounded-[.5rem] pl-[.5rem] flex justify-center items-center mt-3"
              />
              <button
                type="button"
                className="absolute right-20 top-14"
                onClick={handleShowConfirm}
              >
                {showConfirm ? <FaEyeSlash /> : <FaEye />}{" "}
              </button>
            </div>

            <div className="mt-4">
              <p className="font-normal text-[13px] text-gray-400">
                Characteristics of strong passwords
              </p>
              <p className="text-[13px] font-normal mt-4">
                At least 8 characters-the more characters, the better.
              </p>
              <p className="text-[13px] font-normal">
                A mixture of both uppercase and lower letters.
              </p>
              <p className="text-[13px] font-normal">
                A mixture of letters and numbers.
              </p>
              <p className="text-[13px] font-normal">
                Inclusion of at least one special character e.g. !@#?&#93;
              </p>
              <p className="text-gray-400 text-[13px] font-normal mt-6 w-[348px]">
                {" "}
                Note: do not use &lt; or &gt; in your password, as both can
                cause problems in Web browsers.
              </p>
            </div>

            <div className="mt-8">
              <button
                disabled={passwordError || passwordError1}
                type="submit"
                className="bg-text-orange text-white w-[348px] h-[50px] rounded-md disabled:bg-text-orange/20"
              >
                Change Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Password;
